import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ListCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-list-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3.5 5.5l1.5 1.5l2.5 -2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3.5 11.5l1.5 1.5l2.5 -2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3.5 17.5l1.5 1.5l2.5 -2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 6l9 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 12l9 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 18l9 0"
    }, null), _createTextVNode(" ")]);
  }
};